import React from "react";

export function ApprovedCredits() {
  return (
    <section className="bg-sunny-top-left bg-before-purple bg-rounded-top bg-rounded-bottom">
      <div className="container">
        <div className="row my-5">
          <div id="certifications">
            <div className="col">
              <div className="row align-items-center">
                <div className="col-lg-5 col-md-4 order-md-2">
                  <div className="certification-graphics">
                    <div className="certification-graphics-inner">
                      <img
                        className="img-fluid"
                        src="/img/logo-certs.webp"
                        alt="HRCI and SHRM certifications"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-7 col-md-8 order-md-1">
                  <div style={{ maxWidth: "45em", display: "inline-block" }}>
                    <h1 className="color-white mb-0">
                      <span className="white-highlight">FinComp '27</span> is
                      proudly approved by SHRM and HRCI
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
